import styled from "styled-components";

const Style = styled.div`
  position: relative;

  .map-cont {
    height: 500px;
  }

  .sider {
    z-index: 500;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 269px;
    height: 100%;
    background: white;
    padding: var(--size-lg);

    .map-sider-header {
      border-bottom: 1px solid var(--base-gray-30);

      h3 {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 0px;
      }  
    }

    .map-sider-body {
      display: flex;
      flex-direction: column;
      gap: 21px;

      label {
        font-weight: 500;
        margin-bottom: 0px;
        color: var(--base-gray-80);
      }

      span {
        font-weight: 500;
        margin-bottom: 0px;
      }
    }
  }
`;

export default Style;
